import React, {useState} from "react";
import {Input, Link, Image, Button} from "@nextui-org/react";
import {FaUser, FaLock} from "react-icons/fa"
import logo from "./assets/logo.png"
import {Authentication} from "../API";
import {useNavigate} from "react-router-dom";
import {useUser} from "../Private/UserProvider";

export const Login = () => {
    const {setUser} = useUser();
    const [data, setData] = useState([]);
    const [load, setLoad] = React.useState(false)
    const navigate = useNavigate();

    async function handleLogin(e) {
        e.preventDefault();
        setLoad(true);
        const result = await Authentication(data);
        if(!!result)
        {
            setUser(result);
            navigate('/dashboard')
        }else
            setLoad(false);
    }

    function OnChange(e) {
        setData({...data, [e.target.name]: e.target.value});
    }


    return (
        <form className="flex flex-col items-center justify-center min-h-screen bg-gray-100" onSubmit={handleLogin}>
            <div className="w-full max-w-xs">
                <Image src={logo} isBlurred/>
                <h1 className="text-2xl pt-5 pb-5 text-center">Inicio de sesión</h1>
                <div className="space-y-4">
                    <Input
                        autoFocus
                        endContent={<FaUser/>}
                        label="Usuario"
                        variant="bordered"
                        fullWidth
                        value={data.username}
                        onChange={OnChange}
                        name="username"
                        required
                        isRequired
                    />
                    <Input
                        endContent={<FaLock/>}
                        label="Contraseña"
                        type="password"
                        variant="bordered"
                        fullWidth
                        value={data.password}
                        onChange={OnChange}
                        name="password"
                        required
                        isRequired
                    />
                    <div className="flex py-2 px-1 justify-between items-center">
                        <Link color="foreground" href="#" size="sm">
                            ¿Olvidaste tu contraseña?
                        </Link>
                        <Button type="submit" color="danger" isLoading={load}>Iniciar</Button>
                    </div>
                </div>
            </div>
        </form>
    );
};

export default Login;